export default {
  // 状态
  enableStateList: [
    { label: '启用', value: true, color: 'green' },
    { label: '停用', value: false, color: 'red' },
  ],
  typeList: [
    {label: '介绍页', value: 1},
    {label: '新闻页', value: 2},
  ]
};
